import { useHttp } from '../http'

export const useGlossarySectionHttp = () => {

    const find = <T>(id: number, payload: any): Promise<T> => {
        return useHttp().get(`glossary-sections/${id}`, payload)
    }

    const create = <T>(payload: any): Promise<T> => {
        return useHttp().post(`glossary-sections`, payload)
    }

    const update = <T>(id: number, payload: any): Promise<T> => {
        return useHttp().put(`glossary-sections/${id}`, payload)
    }

    const get = <T>(payload: any): Promise<T> => {
        return useHttp().get(`glossary-sections`, payload)
    }

    const del = <T>(id: number): Promise<T> => {
        return useHttp().del(`glossary-sections/${id}`)
    }

    return {
        find,
        create,
        update,
        get,
        del,
    }
}